import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import SlidePanel from 'yoda-account-components/lib/components/SlidePanel/SlidePanel';

const formatChallengePeriod = (startDate = '', endDate = '') => {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    const parseDate = (date) => {
        const datePart = date.toString().split('T')[0];
        const [year, month, day] = datePart.split('-');
        return { year, month: parseInt(month, 10), day: parseInt(day, 10) };
    };

    const start = parseDate(startDate);
    const end = parseDate(endDate);

    if (!start.year || !end.year) return '';

    const startStr = `${months[start.month - 1]} ${start.day}`;
    const endStr = `${months[end.month - 1]} ${end.day}, ${end.year}`;

    return `${startStr} \u2013 ${endStr}`;
};

const ExclusionsSlidePanel = ({ isOpen, challenge, onClose }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'auto';
        }

        return () => {
            document.body.style.overflowY = 'auto';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <SlidePanel
            isOpenPanel={isOpen}
            onClosePanel={onClose}
            showBackIcon={false}
            onPrimaryCloseButtonClick={onClose}
            isPrimaryCloseButtonRequired
            panelTitle="Exclusions & Details"
        >
            <div className={dt(['p-4'])}>
                {challenge && (
                    <div>
                        <h3 className={dt(['text-xlarge', 'font-semibold', 'text-black', 'mb-2'])}>
                            {challenge.shortDescription}
                        </h3>
                        <div className={dt(['text-normal', 'text-black', 'mb-4'])}>
                            Challenge Period:{' '}
                            {formatChallengePeriod(challenge.startDate, challenge.endDate)}
                        </div>
                        {challenge.offerTermsAndConditions ? (
                            <div className={dt(['text-normal', 'text-black', 'mb-4'])}>
                                {challenge.offerTermsAndConditions}
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                )}
            </div>
        </SlidePanel>
    );
};

ExclusionsSlidePanel.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    challenge: PropTypes.shape({
        shortDescription: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        offerTermsAndConditions: PropTypes.string,
    }),
    onClose: PropTypes.func.isRequired,
};

ExclusionsSlidePanel.defaultProps = {
    challenge: null,
};

export default ExclusionsSlidePanel;
